import styled, { css } from 'styled-components';

export const FakeButton = styled.button`
	${({ theme }) => css`
		z-index: 1000000;
		position: fixed;
		right: 0;
		top: 200px;
		pointer-events: auto;
		padding: 0px;
		width: 4.2rem;
		height: 4.2rem;
		display: flex;
		-webkit-box-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		align-items: center;
		font-style: normal;
		font-variant: normal;
		font-weight: 900;
		font-stretch: normal;
		font-size: ${theme.font.sizes.medium};
		line-height: 130%;
		border-style: solid;
		border-color: rgb(255, 255, 255);
		border-image: initial;
		border-width: 1px 0px 1px 1px;
		margin: 0px;
		font-family: Lato, sans-serif !important;
		background: rgb(0, 48, 135) !important;
		border-radius: 12px 0px 0px 12px !important;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			top: 200px;
		}

		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			top: 200px;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			top: 200px;
		}

		@media (min-width: ${theme.breakpoints.ultraWide}) {
			top: 200px;
		}
	`}
`;
